import { render } from "./Navbar.vue?vue&type=template&id=d52c7bfa&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=d52c7bfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d52c7bfa"

export default script